import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import ReactGA from 'react-ga'
import configApi from './api/configApi'
import { clearSession } from './views/pages/login/Logout.helper'

const RouteChangeTracker = ({ history }) => {
  if (process.env.NODE_ENV === 'production') {
    history.listen((location, action) => {
      ReactGA.set({ page: location.pathname })
      ReactGA.pageview(location.pathname)
    })
  }

  useEffect(() => {
    checkMaintenance()
  }, [])

  useEffect(() => {
    if (history?.location?.pathname.indexOf('/Maintenance') < 0) {
      checkMaintenance()
    }
  }, [history?.location?.pathname])

  const checkMaintenance = async () => {
    if (process.env.NODE_ENV !== 'production') return
    try {
      let result = await configApi.checkMaintenance()
      if (
        result?.data?.data?.[0] !== null &&
        result?.data?.data?.[0] !== undefined &&
        result?.data?.data?.[0]?.value?.toString() === '1'
      ) {
        if (window.location.hash.indexOf('/Maintenance') < 0) {
          window.location.replace('/#/Maintenance')
          clearSession()
        }
      } else if (window.location.hash.indexOf('/Maintenance') >= 0) {
        window.location.replace('/')
      }
    } catch (error) {
      console.log('error : ', error)
    }
  }

  return <div></div>
}

export default withRouter(RouteChangeTracker)
